var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChatBubble(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    x: "0px",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0B68AD",
    d: "M100,44.6v4.95c0,0.23-.13.46-0.16,0.69a36,36,0,0,1-8.12,19.43C85.71,77.1,78,82,69,85.07a56.73,56.73,0,0,1-18.26,3,112.75,112.75,0,0,1-15.57-1.29,3.63,3.63,0,0,0-2.5.44,46.38,46.38,0,0,1-18,6.29,46.39,46.39,0,0,1-6.45.35,3,3,0,0,1-2.39-4.68,11.69,11.69,0,0,1,.93-1.29,56.23,56.23,0,0,0,7.14-11.48,0.85,0.85,0,0,0-.23-1.22A41.33,41.33,0,0,1,4.9,64.76,34.86,34.86,0,0,1,.76,54C0.47,52.54.25,51,0,49.55V44.6a8,8,0,0,0,.18-0.85,35.73,35.73,0,0,1,6-16.45,44.71,44.71,0,0,1,14-13.11A54.36,54.36,0,0,1,37.56,7.38a60,60,0,0,1,29,1,52.47,52.47,0,0,1,15,6.9A43.79,43.79,0,0,1,94.33,28.18a34.7,34.7,0,0,1,4.89,11.87C99.52,41.56,99.74,43.08,100,44.6Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chat-bubble.1a41d0a0.svg";
export { ForwardRef as ReactComponent };